export const ROUTES = {
  REIMBURSEMENTS: '/reimbursements',
  // todo - change this route to avoid using '&'
  PAYMENTS_DEDUCTIONS: '/payments&deductions',
  APPLIES: '/applies',
  COMPASS_RIGHTS: '/compass-rights',
  UNIVERSAL_REQUEST: '/universalRequest',
  UNIVERSAL_REQUEST_WITH_PARAMS: (
    param1: number | string,
    param2: number | string,
    param3?: number | string,
  ) => `/universalRequest/${param1}/${param2}/${param3 ? `${param3}` : ''}`,
  UNIVERSAL_REQUEST_SUCCESS: (
    tabId: number | string,
    categoryId: number | string,
    subCategoryId: number | string,
  ) => `/universalRequest/${tabId}/${categoryId}/${subCategoryId}/success`,
  DATA_ANALYSIS: '/admin/data-analysis',
  DATA_ANALYSIS_PROMPT_MANAGER: '/admin/data-analysis/prompt-manager',
  SELF_REFERRAL_GENERATED_LIST: '/admin/self-referral-generated',
  EXPENSE_REFUND_LIST: '/admin/expense-refunds',
  SELF_REFERRAL_ADMIN_DEBUG: '/admin/self-referral-debug',
  SECTOR_TO_SIMUL_PGIMA_ADMIN: '/admin/sector-to-simul-pgima',
  ADMIN_LOGS: '/admin/logs',
  ADMIN_FEEDBACK: 'admin/feedback',
  EMERGENCY_CALL: 'admin/emergency-call',
  // Medical Committees routes
  MEDICAL_COMMITTEES: '/medical-committees',
  MEDICAL_COMMITTEES_DETAILS: (meetNumber: number | string) =>
    `/medical-committees/${meetNumber}`,
  MEDICAL_COMMITTEES_ADD_CONTACT: '/medical-committees/add-contact',
  MEDICAL_COMMITTEES_ADD_CONTACT_SUCCESS:
    '/medical-committees/add-contact/success',
  MEDICAL_COMMITTEES_RECORDINGS: '/medical-committees/recordings',
  MEDICAL_COMMITTEES_CONTACTS: '/medical-committees/contacts',
  MEDICAL_COMMITTEES_CLOSED: '/medical-committees/closed',
  MEDICAL_COMMITTEES_FINISHED: '/medical-committees/finished',
  MEDICAL_COMMITTEES_APPEAL: '/universalRequest/1/10/51',
  MEDICAL_COMMITTEES_UPLOAD_MEDICAL_OPINION: '/universalRequest/1/10/137',
  MEDICAL_CAR: '/universalRequest/1/3/45',
  MEDICAL_REFERRALS: '/medical-referrals',
  MEDICAL_REFERRALS_DETAILS: (id: number | string) =>
    `/medical-referrals/${id}`,
  SELF_SERVICE_REFERRALS: '/self-service-referrals',
  LONG_TERM_EQUIPMENT: '/longterm-equipment',
  DOCUMENTS: '/documents-new',
  TREATMENT: '/treatment',
  RECOGNITION_STATUS: '/recognitionStatus',
  MEDICINE: '/medicine',
  MEDICATION_HISTORY: '/medicine/medicationHistory',
  EQUIPMENT: '/equipment',
  CONTACT_DEPARTMENT: '/universalRequest/1/3/',
  SELF_SERVICE_CONTACT_DEPARTMENT: '/universalRequest/1/1/77',
  EQUIPMENT_CONTACT_DEPARTMENT: '/universalRequest/1/2/3',
  // Refunds
  REFUNDS_MEDICAL_EQUIPMENT: '/refunds/medical-equipment',
  REFUNDS_MEDICAL_EQUIPMENT_FALLBACK: '/universalRequest/1/12/129',
  MENTAL_HEALTH_CONTACT_DEPARTMENT: '/universalRequest/1/13/80',
  FAMILY_COMPOSITION_UPDATE: '/universalRequest/1/8/91',
} as const;

export const buildMentalHealthContactDepartmentUrl = (note?: string) =>
  note
    ? `${ROUTES.MENTAL_HEALTH_CONTACT_DEPARTMENT}?note=${encodeURIComponent(note)}`
    : ROUTES.MENTAL_HEALTH_CONTACT_DEPARTMENT;
